import { Checkbox } from "@material-ui/core"
import { useDefaultTableStyling as sytlingOptions } from "./globalStyle"
import { Strings } from '../assets/res/en'
import { modules } from '../utils/config'
export default function permissionDataColumn(canUpdate, handleRowDataChange, isProfileChangeDisabled) {
    const perColumns = [
        { title: Strings.MODULE, field: 'module', editable: 'never' },
        {
            title: Strings.CREATE, field: 'create', type: 'boolean',
            render: rowData => (
                <Checkbox color="primary"
                    defaultChecked={rowData.create}
                    disabled={canUpdate === false || (rowData.moduleId === modules.profiles.id && isProfileChangeDisabled)}
                    onChange={(e) => handleRowDataChange('create', e.target.checked, rowData)} />
            )
        },
        {
            title: Strings.READ, field: 'read', type: 'boolean',
            render: rowData => (
                <Checkbox color="primary"
                    defaultChecked={rowData.read}
                    disabled={canUpdate === false || (rowData.moduleId === modules.profiles.id && isProfileChangeDisabled)}
                    onChange={(e) => handleRowDataChange('read', e.target.checked, rowData)} />
            )
        },
        {
            title: Strings.UPDATE, field: 'update', type: 'boolean',
            render: rowData => (
                <Checkbox color="primary"
                    defaultChecked={rowData.update}
                    disabled={canUpdate === false || (rowData.moduleId === modules.profiles.id && isProfileChangeDisabled)}
                    onChange={(e) => handleRowDataChange('update', e.target.checked, rowData)} />
            )
        },
        {
            title: Strings.DELETE, field: 'delete', type: 'boolean',
            render: rowData => (
                <Checkbox color="primary"
                    defaultChecked={rowData.delete}
                    disabled={canUpdate === false || (rowData.moduleId === modules.profiles.id && isProfileChangeDisabled)}
                    onChange={(e) => handleRowDataChange('delete', e.target.checked, rowData)} />
            )
        }
    ]
    return { perColumns, sytlingOptions }
}